class StoryCarousel extends HTMLElement {
  constructor() {
    super();
    this.swiperEl = this.querySelector('.story-carousel__swiper');
    this.mediaEl = this.querySelector('[data-story-media]');
    this.titleEl = this.querySelector('[data-story-title]');
    this.contentEl = this.querySelector('[data-story-content]');
    this.prevButton = this.querySelector('[data-story-prev]');
    this.nextButton = this.querySelector('[data-story-next]');
  }

  connectedCallback() {
    if (!this.swiperEl) return;

    // Captured up front, before Swiper touches the DOM, and read back by
    // array index on slide change rather than off the live slide element.
    this.slidesData = Array.from(this.querySelectorAll('.story-carousel__slide')).map((slide) => ({
      title: slide.dataset.title || '',
      content: slide.dataset.content || '',
    }));

    // Shopify wraps every block rendered via `content_for 'blocks'` in its
    // own `.shopify-block` div, but swiper-container requires its direct
    // children to be exactly <swiper-slide> elements — unwrap those divs
    // so Swiper can find the slides. block.shopify_attributes is already
    // on the <swiper-slide> itself, so editor block-selection still works.
    this.unwrapShopifyBlocks(this.swiperEl);

    // Each slide carries its own large image nested inside it (rather than
    // the section reading it from section.blocks directly, which isn't
    // reliable for content_for-rendered blocks). Relocate each one into
    // the right-hand media column here, keeping them in slide order so
    // they can be toggled by index alongside the swiper.
    this.mediaItems = Array.from(this.querySelectorAll('.story-carousel__slide [data-story-media-item]')).map((item) => {
      item.hidden = false;
      this.mediaEl.appendChild(item);
      return item;
    });

    Object.assign(this.swiperEl, {
      navigation: {
        prevEl: this.prevButton,
        nextEl: this.nextButton,
      },
    });
    this.swiperEl.initialize();

    const swiper = this.swiperEl.swiper;
    if (!swiper) return;

    swiper.on('slideChange', this.updateInfo);
    this.updateInfo();
  }

  unwrapShopifyBlocks(container) {
    container.querySelectorAll(':scope > .shopify-block').forEach((wrapper) => {
      while (wrapper.firstChild) {
        wrapper.parentNode.insertBefore(wrapper.firstChild, wrapper);
      }
      wrapper.remove();
    });
  }

  updateInfo = () => {
    const swiper = this.swiperEl.swiper;
    if (!swiper) return;

    const data = this.slidesData[swiper.activeIndex];
    if (data) {
      if (this.titleEl) this.titleEl.textContent = data.title;
      if (this.contentEl) this.contentEl.innerHTML = data.content;
    }

    this.mediaItems.forEach((item, index) => {
      item.classList.toggle('is-active', index === swiper.activeIndex);
    });
  };
}

customElements.define('story-carousel', StoryCarousel);
